import styled from '@emotion/styled';

export const Padded = styled.div`
    padding: 20px;
`;
